<template>
    <div class="container-fluid">

        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <v-app>
                        <v-container fluid>
                            <v-card elevation="2" outlined>
                                <v-card-title>
                                    <!--                                    v-if="$can('transaction_create')"-->

                                    <v-spacer/>
                                    {{ $route.meta.title }}
                                    <v-spacer/>


                                </v-card-title>
                                <v-divider/>

                                <div class="row">

                                    <div class="col-md-12 p-5">
                                        <data-table
                                            :data="userInfo"
                                            :columns="columns"
                                            :translate="translate"
                                            :per-page="[10, 25, 50, 100]"
                                            @on-table-props-changed="reloadTable">
                                          <div slot="filters" slot-scope="{ tableFilters, perPage }">
                                            <div class="row mb-2">
                                              <div class="col-md-4">
                                                <select class="form-control pr-3" v-model="tableFilters.length">
                                                  <option :key="page" v-for="page in perPage">{{ page }}</option>
                                                </select>
                                              </div>
                                              <div class="col-md-4">
                                              </div>

                                              <div class="col-md-4 ">
                                                <v-text-field
                                                v-model="tableFilters.search"
                                                outlined
                                                dense
                                                label="جست و جو"
                                                class="pl-3"
                                                >

                                                </v-text-field>
                                              </div>
                                            </div>
                                          </div>

                                        </data-table>
                                    </div>
                                </div>
                            </v-card>
                        </v-container>
                    </v-app>
<!--                      <Wallet  :dialog="dialog" v-model="dialog" :wallet="userWallet" />-->

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {SET_BREADCRUMB} from "../../../../core/services/store/breadcrumbs.module";
import userManageButton from "@/view/pages/admin/users/userManageButton";
import Wallet from "./actions/Wallet";
import loginRollback from "@/Utilities/LoginRollback";
import jwtService from "@/core/services/jwt.service";
import CheckboxFild from "@/view/pages/admin/users/CheckboxFild";

export default {
  components: {Wallet},
  data() {
        return {
          selectedRows : [],
          dialog: false,
          userWallet: [],
          dialogInfo: null,

            translate: {
                nextButton: 'بعدی',
                previousButton: 'قبلی',
                rowsPerPageText: 'تعداد در صفحه',
                noDataText: 'داده ای برای نمایش وجود ندارد',
                placeholderSearch: 'جستجو',
            },
            url: 'admin/users',
            userInfo:{},
            tableProps: {
                search: '',
                length: 10,
                column: 'id',
                dir: 'desc',
            },
            columns: [
              {
                label: `<input type="checkbox" id="select_all" onclick="window.Vue.$emit('selectAllListCheckBox', this)"/>`,
                component: CheckboxFild,
                event: 'change',
                handler: this.change,
              },
              {
                label: 'ردیف' ,
                transform: (val) => {
                  console.log(this.userInfo)
                  let row = this.userInfo.current_page -1;
                  row = row * this.userInfo.per_page;
                  return row + val.row + 1;
                },
              },
                {
                    label: 'شناسه',
                    name: 'id',
                    orderable: true,
                    colStyle: 'width: 100px;'
                },
                {
                    label: 'نام',
                    name: 'name',
                    orderable: true,
                },
                {
                    label: 'نام کاربری',
                    name: 'username',
                    orderable: true,
                },
                {
                    label: 'تلفن',
                    name: 'phone',
                    orderable: true,
                },

              {
                label: 'پنل',
                name: 'pack',
                transform: (value, data) => {
                  return value.data.pack.title;
                }
              },


                {
                    label: 'نوع کاربر',
                    name: 'type',
                    orderable: true,
                    transform: (value, data) => {
                        return value.data.type == 'regular' ? 'شخص حقیقی' : 'شخص حقوقی';
                    }
                },

                {
                    label: 'عملیات',
                    name: 'actions',
                    component: userManageButton,
                    handler: this.actions,
                    event: 'action',
                  meta: {
                    permission_prefix: 'user_',
                  }
                },
            ],
        }
    },
    created() {
        this.$store.dispatch(SET_BREADCRUMB, [{title: this.$route.meta.title}])
        this.getUserInfo(this.url)

        window.Vue.$on('selectAllListCheckBox', (e)=>{
          this.selectAll(e.checked);
        })
    },

    methods: {
    selectAll(c) {
      window.Vue.$emit("selectedAllCheckbox", c);
    },
    change(data, checked) {
      if (checked){
        this.selectedRows.push(data.id);
      }else{
        let index = this.selectedRows.indexOf(data.id)
        this.selectedRows = [
            ...this.selectedRows.slice(0, index),
            ...this.selectedRows.slice(index + 1 , this.selectedRows.length)
        ]

      }
      window.document.querySelector("#select_all").checked = this.selectedRows.length == this.userInfo.data.length

      console.log(data.id)
    },

    filterOnlyCapsText(value, search, item) {
        return value != null &&
            search != null &&
            typeof value === 'string' &&
            value.toString().toLocaleUpperCase().indexOf(search) !== -1
    },

        getUserInfo(url = this.url, params = this.tableProps) {
            this.requestApiGet(url, params).then(response => {
              this.userInfo = response.data;
            })
        },

        reloadTable(params) {
            this.getUserInfo(this.url, params)
        },

        actions(data, type) {
          this[type](data)
        },
      edit(data) {
        this.$router.push({name: 'admin.user.edit', params: {id: data.id}})
      },
      information(data) {
        this.$router.push({name: 'admin.users.information', params: {id: data.id}})
      },
      wallet(data) {
        this.$router.push({name: 'admin.users.walletEdit', params: {id: data.id}})

        // if (data.wallets.length > 0) {
        //   this.dialog = true;
        //   return this.userWallet = data;
        // }
        // this.$toast.warning('کیف پول کاربر در حال حاضر وجود ندارد')
        // this.$router.push({name: 'admin.users.wallet', params: {id: data.id}})
      },
      checkout(data) {
          this.$modal.showLoading();
          this.getUserTokenWithId(data.id)
              .then((token)=>{
                loginRollback.addLogin(this.getUser().name, jwtService.getToken())
                jwtService.saveToken(token)
                window.location.reload();
              }).catch((e)=>{
            this.$toast.error("error")
              })
              .finally(()=>{
                this.$modal.hideLoading();
              })
      },
    }
}

$('#select_all').click(function () {
    $('.checkBox').prop('checked', $(this).prop("checked"));
  })
</script>
